import React, { SyntheticEvent } from 'react';
import { Link } from 'react-router-dom';

export const DiscoverCredentialsModal = (props) => {
  const finalImageUrl = (credential) =>
    credential.iconImage || '/images/default_badge.png';

  const handlePopUpClose = () => {
    props.closePopUp();
  };

  return (
    <div className="popup_div active">
      <div className="popup_cont sk">
        <div data-name="followers" className="dc_popup active">
          <div className="div-block-520">
            <div>Discover Credentials</div>
            <img
              onClick={handlePopUpClose}
              src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacfc_close.png"
              loading="lazy"
              alt=""
              className="cancel_dc"
            />
          </div>
          <div className="div-block-525 cr_res">
            <div className="div-block-469 sk_s">
              <div className="form-block-15 s_skill w-form">
                <form
                  id="email-form"
                  name="email-form"
                  data-name="Email Form"
                  method="get"
                  className="form-10"
                  data-wf-page-id="6596f726bb7395ad7c5fe5ef"
                  data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb83711f"
                  aria-label="Email Form"
                >
                  <div className="div-block-410">
                    <img
                      src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacc8_magnifying-glass.png"
                      loading="lazy"
                      alt=""
                      className="image-164"
                    />
                  </div>
                  <input
                    className="text-field-14 n_text w-input"
                    maxLength={256}
                    name="email-4"
                    data-name="Email 4"
                    placeholder="Search for credentials"
                    type="email"
                    id="email-4"
                    required
                    control-id="ControlID-3"
                  />
                </form>
                <div
                  className="w-form-done"
                  tabIndex={-1}
                  role="region"
                  aria-label="Email Form success"
                >
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div
                  className="w-form-fail"
                  tabIndex={-1}
                  role="region"
                  aria-label="Email Form failure"
                >
                  <div>
                    Oops! Something went wrong while submitting the form.
                  </div>
                </div>
              </div>
            </div>

            <div className="cred_res">
              {props.discoverCredentials.map((credential, index) => {
                return (
                  <Link
                    key={credential.entityId}
                    to={`/courses/${credential.courses[0].course_id}`}
                    className="cred_link cr_r w-inline-block"
                  >
                    <div className="cr_box_flex cr_res">
                      <img
                        src={finalImageUrl(credential)}
                        loading="lazy"
                        sizes="100vw"
                        onError={(e: SyntheticEvent<EventTarget, Event>) => {
                          (e.target as HTMLImageElement).src =
                            '/images/default_badge.png';
                        }}
                        className="image-153 cr_res"
                      />
                      <div>
                        <div className="text-block-232">{credential.name}</div>
                        <div className="text-block-239">
                          {credential.issuerDetails.name}
                        </div>
                        <div className="text-block-239">
                          {credential.courses[0].name}
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
          <div className="popup-f">
            <div className="div-block-475 cancel_dc_div">
              <div
                className="text-block-284 cancel_dc"
                onClick={handlePopUpClose}
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
